export enum SitePage {
  About = "about",
  Admin = "admin",
  Error = "error",
  Feed = "feed",
  Home = "home",
  Login = "login",
  Map = "map",
  Place = "place",
  Profile = "profile",
  Registration = "registration",
  Settings = "settings",
}
